import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@wundo/ui';
import { MemoryList } from './MemoryList.tsx';

export interface MemoryViewerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  userId: string;
  offeredHandles?: string[];
}

/** The same list, over a transcript: what the agent knew as it answered. */
export function MemoryViewerDialog({
  open,
  onOpenChange,
  userId,
  offeredHandles,
}: MemoryViewerDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size='md'>
        <DialogHeader>
          <DialogTitle>Memories</DialogTitle>
        </DialogHeader>
        <div className='px-5 py-4'>
          {open && <MemoryList userId={userId} offeredHandles={offeredHandles} />}
        </div>
      </DialogContent>
    </Dialog>
  );
}
